import * as React from "react";
import Container from "../components/Container";
import { Header } from "../components/Page";
import JSONEditor from "../components/JSONEditor";

const EditPrivacyPolicy = () => {
  return (
    <Container>
      <Header selected="Privacy Policy" />
      <JSONEditor path="templates/privacyPolicy" />
    </Container>
  );
};

export default EditPrivacyPolicy;
